// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-gZa","type":"styles_type__2Y2k4","choices":"styles_choices__1ajaN"};